
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmRectifiedOutlined as ObiAlarmRectifiedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-rectified-outlined.js';
 
 
 

 
 export const ObiAlarmRectifiedOutlined = createComponent({
   react: React,
   tagName: 'obi-alarm-rectified-outlined',
   elementClass: ObiAlarmRectifiedOutlinedElement,
   events: {
     
   }
  });
 
 